import { ParentProps, Show, createContext, createEffect, createSignal } from 'solid-js'
import { requireContext } from 'common'
import { K12NewyearinfoSetupWizardProgressBarContext } from './K12NewyearinfoSetupWizardProgressBarContext'
import styles from './sis-k12-newyearinfo-setup-wizard-progress-bar.module.css'
import { STComponentWrapperProps } from 'st-app';

const K12NewyearinfoSetupWizardProgressBarContextJsx = createContext<K12NewyearinfoSetupWizardProgressBarContext>();
export const requireK12NewyearinfoSetupWizardProgressBarContext = () => {
    return requireContext(K12NewyearinfoSetupWizardProgressBarContextJsx);
}

export class K12NewyearinfoSetupWizardProgressBarProps extends STComponentWrapperProps { }

export default function K12NewyearinfoSetupWizardProgressBar(props: ParentProps<K12NewyearinfoSetupWizardProgressBarProps>) {
    const context = new K12NewyearinfoSetupWizardProgressBarContext();

    return (
        <K12NewyearinfoSetupWizardProgressBarContextJsx.Provider value={context}>
            <K12NewyearinfoSetupWizardProgressBarInternal {...props} />
        </K12NewyearinfoSetupWizardProgressBarContextJsx.Provider>
    )
}

function K12NewyearinfoSetupWizardProgressBarInternal(props: ParentProps<K12NewyearinfoSetupWizardProgressBarProps>) {

    const [completion, setCompletion] = createSignal<number>(0);

    createEffect(() => {
        if (props.value)
        {
            setCompletion(parseFloat(props.value))
        }
    })

    return (
        <div class={styles['sis-k12-newyearinfo-setup-wizard-progress-bar']}>
            <div class={styles['progressBarContainer']}>
                <div class={styles['progressBarStatus']} style={{ width: `${completion() * 100}%` }}></div>
                <span class={styles['progressBarLabel']}>{completion() * 100}%</span>
            </div>
        </div>
    );
}

K12NewyearinfoSetupWizardProgressBar.defaultProps = new K12NewyearinfoSetupWizardProgressBarProps();